// extracted by mini-css-extract-plugin
module.exports = {"green":"#134981","hover":"#f1f8ff","orange":"#ff8a00","grey":"#777"};